module.exports = __webpack_public_path__ + "static/customize_6-2f9e68094799cc74c889a783117347fc.png";